import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="public-footer">
      <div className="public-footer-grid">
        <section className="public-footer-section">
          <h2>DR Rentals</h2>
          <p>Handelsnaam van Cedric Coudijzer</p>
          <p>Verhuur van aanhangwagens</p>
          <p>
            Ondernemingsnummer:<br />
            BE 0720.658.431
          </p>
          <p>
            0479 65 88 28<br />
            info@dr-rentals.be
          </p>
        </section>

        <section className="public-footer-section">
          <h2>Snelle links</h2>
          <Link to="/">Home</Link>
          <Link to="/">Trailers</Link>
          <Link to="/contact">Contact</Link>
        </section>

        <section className="public-footer-section">
          <h2>Informatie</h2>
          <Link to="/veelgestelde-vragen">Veelgestelde vragen</Link>
          <Link to="/privacybeleid">Privacybeleid</Link>
          <Link to="/algemene-voorwaarden">Algemene Voorwaarden</Link>
        </section>

        <section className="public-footer-section">
          <h2>Volg ons</h2>
          <span>Facebook</span>
          <span>Instagram</span>
        </section>
      </div>

      <div className="public-footer-bottom">
        <span>© 2026 DR Rentals - Handelsnaam van Cedric Coudijzer - Alle rechten voorbehouden.</span>
        <span>Ontwikkeld door Digital Reach</span>
      </div>
    </footer>
  );
}
